import { OrderLine } from './order-line';

export class Order {
  public id: number;
  public orderCode: string;
  public userName: string;
  public status: string;
  public userId: string;
  public orderLines: OrderLine[];
  public role: string;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/_model/order.ts